import { defineMessages } from "react-intl";

export type PropertyTypes =
	| "Share"
	| "Cadastre"
	| "Stock"
	| "Project"
	| "Unknown";

export const propertyMessage = defineMessages<PropertyTypes>({
	Share: {
		id: "template-form.property.propertyType.share",
		defaultMessage: "Share"
	},
	Cadastre: {
		id: "template-form.property.propertyType.cadastre",
		defaultMessage: "Cadastre"
	},
	Stock: {
		id: "template-form.property.propertyType.stock",
		defaultMessage: "Stock"
	},
	Project: {
		id: "template-form.property.propertyType.project",
		defaultMessage: "Project"
	},
	Unknown: {
		id: "template-form.property.propertyType.unknown",
		defaultMessage: "Unknown"
	}
});

export interface HouseOwner {
	houseOwnerId: number;
	uniquePropertyId: string;
	applicationPropertyId?: number;
	dateOfBirth: Date;
	organizationNumber: string;
	personalNumber?: string;
	name?: string;
	email?: string;
	phone?: string;
	isNorwegianCitizen: boolean;
	owningFractionNumerator?: number;
	owningFractionDenominator: number;
	isResident: boolean;

	displayValue: string;
}

export interface Lien {
	lienId: number;
	uniquePropertyId: string;
	lienType?: string;
	infoAsText?: string;
	creditorOrgNo?: string;
	creditorName?: string;
	registrationDate?: Date;
	priority?: string;
	yieldPriority?: boolean;
	documentId?: string;
	value?: number;
	writtenDownValue?: number;
	addedManually?: boolean;
	reuseLien?: boolean;
}

export interface SpecialConstraint {
	specialConstraintId: number;
	documentId: string;
	registrationDate: Date;
	name: string;
	warningLevel?: number | null;
	isJudicialRegistered?: boolean | null;
}

export interface Property {
	applicationPropertyId: number;
	applicationId: number;
	propertyInformation: string;
	uniquePropertyId: string;
	type: PropertyTypes;
	cadastralNumber: string;
	streetName?: string;
	addressNumber?: number;
	addressLetter?: string;
	municipalityNumber?: number;
	postalCode?: string;
	postalPlace?: string;
	unitNumber?: number;
	leaseholdUnitNumber?: number;
	refinance?: boolean;
	valueEnteredByCustomer?: number;
	mainCustomerResidence?: boolean;
	estimatedValue?: number;
	pledgeValue?: number;
	cadastralUnitNumber?: number; // Only for cadastres
	priority?: number;

	housingCooperativeOrgNumber?: string; // Only for shares or stock
	housingCooperativeOrgName?: string; // Only for shares or stock
	shareNumber?: number; // Only for shares or stock
	housingCooperativeName?: string; // Only for shares
	jointDebt?: number; // Only for shares

	businessManager?: string;
	apartmentNumber?: string;

	utilizedValue?: number;
	utilizedSecurityValue?: number;

	freeText?: string;

	owners?: HouseOwner[];
	newOwners?: HouseOwner[];
	liens?: Lien[];
	newLiens?: Lien[];
	specialConstraints?: SpecialConstraint[];

	eAppraisalReference?: string;
	eAppraisalDate?: Date;
	deleted?: boolean; // Used to delete property when mapping to session
}
